import { createRequestTypes } from '@shopee/redux-commons';

export const FETCH_PRODUCT = createRequestTypes('FETCH_PRODUCT');
export const FETCH_ITEM_DETAIL = createRequestTypes('FETCH_ITEM_DETAIL');
export const FETCH_PRODUCT_SHIPPING_BY_ADDRESS = createRequestTypes(
  'FETCH_PRODUCT_SHIPPING_BY_ADDRESS'
); // will be deperated after https://jira.shopee.io/browse/SPDL-14694 is fully released
export const FETCH_PRODUCT_SHIPPING = createRequestTypes(
  'FETCH_PRODUCT_SHIPPING'
); // this is the new action name for fetching shipping info
export const FETCH_PRODUCT_INSTALLMENT_PLAN = createRequestTypes(
  'FETCH_PRODUCT_INSTALLMENT_PLAN'
);
export const HYDRATE_PRODUCT = 'HYDRATE_PRODUCT';
export const FETCH_BATCH_PRODUCT = createRequestTypes('FETCH_BATCH_PRODUCT');
